/**
 * Created with IntelliJ IDEA.
 * User: shlomif
 * Date: 4/27/14
 * Time: 3:08 PM
 * To change this template use File | Settings | File Templates.
 */

define(function (require) {
    "use strict";

    var Marionette = require("marionette");
    var template = require("templates/top-level-menu/topLevelMenuStatusItem.tmpl");

    var TopLevelMenuStatusItemView = Marionette.ItemView.extend({
        template: template,
        className: "top-level-menu-status-item",
        ui: {
            icon: ".top-level-menu-status-icon",
            arrowIcon: ".top-level-menu-status-arrow-icon"
        },
        events: {
            "click": "_menuItemClicked"
        },
        modelEvents: {
            "change": "_refreshView"
        },
        onRender: function() {
            this.$el.addClass(this.model.get("className"));
            this._refreshView();
        },
        _refreshView: function () {
            this._updateSelectedClass();
            this._updateOpenClass();
            this._updateCustomReasonsArrow();
        },
        _updateSelectedClass: function() {
            this.$el.toggleClass("selected", this.model.isSelected());
        },
        _updateOpenClass: function() {
            this.$el.toggleClass("open", this.model.isOpen());
        },
        _updateCustomReasonsArrow: function() {
            var customReasonsCollection = this.model.getCustomReasons();
            this.ui.arrowIcon.toggleClass("hide", _.isEmpty(customReasonsCollection));
        },
        _menuItemClicked: function (e) {
            this.trigger("click", e);
        }
    });
    return TopLevelMenuStatusItemView;
});
